import { endpoint } from './api'

const config = endpoint('config', ['all', 'one'])

export default {
    ...config
}
